import { useEffect, useRef } from 'react';

const services = [
  {
    icon: 'ri-palette-line',
    title: 'Design graphique',
    description: 'Création de visuels et supports de communication adaptés à vos besoins et à votre audience.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Identité visuelle',
    description: 'Développement d\'une image cohérente et reconnaissable pour construire une marque forte.',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Conception créative',
    description: 'Création de concepts originaux et adaptés aux exigences spécifiques de chaque projet.',
  },
];

export default function ServicesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.service-card').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 120);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 lg:py-36 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 lg:mb-24">
          <p className="text-xs font-semibold text-neutral-400 uppercase tracking-widest mb-4">Services</p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-neutral-900 font-light leading-tight">
            Ce que nous<br />
            <em className="italic">proposons</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {services.map((service) => (
            <div
              key={service.title}
              className="service-card border-t border-neutral-200 pt-8 transition-all duration-700"
              style={{ opacity: 0, transform: 'translateY(24px)' }}
            >
              <div className="w-10 h-10 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-neutral-400`} />
              </div>
              <h3 className="font-heading text-2xl text-neutral-900 font-medium mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-neutral-500 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
